export const computeUtilityTotalUsageKwh = (utility) => {
  if (!utility || typeof utility !== 'object') return null;

  // Primary: what UtilityDetails.js uses for "Yearly Usage (kWh)"
  const direct =
    utility.totalUsage ??
    utility.total_usage ??
    utility.yearly_usage ??
    utility.yearlyUsage;
  if (direct !== undefined && direct !== null && direct !== '') {
    const n = Number(direct);
    return Number.isFinite(n) ? n : null;
  }

  // Fallback: sum monthly usage array
  const usage = utility.usage;
  if (Array.isArray(usage) && usage.length > 0) {
    const sum = usage.reduce((acc, v) => acc + (Number(v) || 0), 0);
    return Number.isFinite(sum) ? sum : null;
  }

  // Fallback: derive from average monthly usage
  const avg = utility.average_usage ?? utility.averageUsage;
  if (avg !== undefined && avg !== null && avg !== '') {
    const n = Number(avg);
    return Number.isFinite(n) ? n * 12 : null;
  }

  return null;
};


